import { Component, Input } from '@angular/core';
import { VersionInfo } from '../../navigation/navigation.service';

@Component({
  selector: 'aio-mode-banner',
  template: `
  <div *ngIf="mode == 'archive'" class="mode-banner alert archive-warning">
    <p>This is the <strong>archived documentation for Angular v{{version?.major}}.</strong>
    Please visit <a href="https://angular.io/">angular.io</a> to see documentation for the current version of Angular.</p>
  </div>
  `
})
export class ModeBannerComponent {
  @Input() mode: string;
  @Input() version: VersionInfo;
}
